import type { ReactNode } from "react";

import type { MessageV2Dto, PollDto } from "@/api/types";
import { Card } from "@/design-system/Card";
import { ContentBlock } from "@/design-system/ContentBlock";
import { Stack } from "@/design-system/Stack";

import { CommunityMessageEvent } from "./CommunityMessageEvent";
import { CommunityPollResultSection } from "./CommunityPollResultSection";
import { CommunityPollVoteForm } from "./CommunityPollVoteForm";

export function CommunityMessageAttachments({ message }: { message: MessageV2Dto }): ReactNode {
  if (message.deletedAt || message.archivedAt || (!message.event && !message.poll)) {
    return null;
  }

  const translatedEventTitle = message.autoTranslation?.title;
  const eventImage = message.images?.[0];

  return (
    <Stack gap="md">
      {message.event && (
        <ContentBlock width="flow" align="left">
          <CommunityMessageEvent
            event={message.event}
            title={translatedEventTitle ?? message.title}
            image={eventImage}
          />
        </ContentBlock>
      )}
      {message.poll && <CommunityMessagePoll poll={message.poll} />}
    </Stack>
  );
}

function CommunityMessagePoll({ poll }: { poll: PollDto }) {
  const translation = poll.autoTranslation;
  const question = translation?.question ?? poll.question;
  const answers = translation?.answers ?? poll.answers;
  const results = translation?.results ?? poll.results ?? [];

  return (
    <Card>
      <p className="text-heading-3" data-testid="poll-question">
        {question}
      </p>
      {poll.canRespond === "yes" ? (
        <CommunityPollVoteForm poll={poll} answers={answers} />
      ) : (
        <CommunityPollResultSection poll={poll} results={results} />
      )}
    </Card>
  );
}
